import { mpWxEvent, webEvent } from '@/core/eventHandle';
import { getUrlParamsObj } from '@/utils/basicTool';
import type { IBaseTrackData, IExtraTrackData, IParamData } from '@/types/DataStore.ts';

export const mpWxProxy = {
  App: {
    snapData: {} as any,
    onLaunch(opts) {
      console.log('App onLaunch', opts);
      const trackParam = {
        param: opts.query,
        scene: opts.scene,
        channel1: opts.query?.channel1,
        channel2: opts.query?.channel2,
      };
      mpWxEvent.handleAppLaunch(trackParam);
    },
    onShow(opts) {
      console.log('App onShow opts', opts);
      const trackParam = {
        param: opts.query,
        scene: opts.scene,
        channel1: opts.query?.channel1,
        channel2: opts.query?.channel2,
      };
      mpWxEvent.handleAppShow(trackParam);
    },
    onHide(opts) {
      console.log('App Hide: ', opts);
    },
  },
  Page: {
    onLoad(opts) {
      console.log('Page onLoad Opts', opts, this);
      console.log('wx: ', wx, getApp(), getCurrentPages());
      mpWxEvent.handlePageLoad.call(this, opts);
    },
    onShow(opts) {
      // @ts-ignore
      const _opts = this?.options || {};
      const trackBase = {
        channel1: _opts?.channel1,
        channel2: _opts?.channel2,
      };
      const trackExtra = {
        param: _opts,
      };
      mpWxEvent.handlePageOpts.call(this, {
        baseOpts: trackBase,
        extraOpts: trackExtra,
      });
      console.log('Page onShow Opts: ', opts, this);
      mpWxEvent.handlePageEnter.call(this, opts);
    },
    onHide(opts) {
      mpWxEvent.handlePageLeave(opts);
    },
    onUnload(opts) {
      mpWxEvent.handlePageLeave(opts);
    },
  },
};

export const webProxy = {
  App: {
    onLaunch() {
      console.log('web location', location);
      const urlParams = (getUrlParamsObj() as IParamData | null) || undefined;
      console.log('urlParams: ', urlParams);
      webEvent.handleAppLaunch(urlParams);
    },
  },
  Page: {
    onShow() {
      const urlParams = (getUrlParamsObj() as IParamData | null) || undefined;
      webEvent.handlePageEnter(urlParams);
    },
    onLeave(obj?: IBaseTrackData | IExtraTrackData) {
      webEvent.handlePageLeave({ extraReport: obj });
    },
  },
};

const eventProxy = {
  mpWxProxy,
  webProxy,
};

export default eventProxy;
